var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebpack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "m35 0 30.934 17.5v35L35 70 4.066 52.5v-35Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#8ed6fb",
      fillOpacity: 1
    },
    d: "M60.41 51.293 36.02 65.09V54.344l15.195-8.36Zm1.668-1.512V20.93l-8.926 5.152v18.543ZM9.492 51.293 33.88 65.09V54.344l-15.195-8.36Zm-1.668-1.512V20.93l8.922 5.152v18.543Zm1.043-30.718L33.88 4.91V15.3l-16.024 8.813-.12.07Zm52.168 0L36.02 4.91V15.3l16.027 8.813.121.07Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1c78c0",
      fillOpacity: 1
    },
    d: "m33.879 51.898-14.992-8.242V27.324l14.992 8.656v15.918m2.14 0 14.993-8.242V27.324L36.02 35.98v15.918M19.902 25.434l15.051-8.278 15.05 8.278-15.05 8.691-15.05-8.691"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebpack);
export default __webpack_public_path__ + "static/media/webpack.fc859ec35dd246dfdb93dfa0369703db.svg";
export { ForwardRef as ReactComponent };